module.exports = __webpack_public_path__ + "img/1536220334.23be147e.jpg";